import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconGuidanceContinue = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2.25C1.41421 2.25 1.75 2.58579 1.75 3L1.75 13C1.75 13.4142 1.41421 13.75 0.999999 13.75C0.585786 13.75 0.25 13.4142 0.25 13L0.25 3C0.25 2.58579 0.585786 2.25 1 2.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 8C12.75 8.41421 12.4142 8.75 12 8.75L5 8.75C4.58579 8.75 4.25 8.41421 4.25 8C4.25 7.58579 4.58579 7.25 5 7.25L12 7.25C12.4142 7.25 12.75 7.58579 12.75 8Z"
        fill="#currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5303 7.46967C13.8232 7.76256 13.8232 8.23744 13.5303 8.53033L10.5303 11.5303C10.2374 11.8232 9.76256 11.8232 9.46967 11.5303C9.17678 11.2374 9.17678 10.7626 9.46967 10.4697L11.9393 8L9.46967 5.53033C9.17678 5.23744 9.17678 4.76256 9.46967 4.46967C9.76256 4.17678 10.2374 4.17678 10.5303 4.46967L13.5303 7.46967Z"
        fill="#currentColor"
      />
    </SvgIcon>
  ))
);
